import type { CardHooks } from "./registry";

/**
 * The Final Straw — Medium Slash A/D with discard-for-bonus.
 *
 * Attack mode: Power 4. On play, surface a `pick-discard-for-bonus` prompt
 * letting the player discard any number of hand cards; each card discarded
 * grants +1 power on this attack (delivered via adValueOverrides on the
 * pushed combat slot).
 *
 * Defend mode: Deflect 4. Same prompt shape, but mode="defend" so each
 * discard grants +1 block on the played defend.
 *
 * Counter ability ("if the opponent drew a card at any point this round,
 * right after they draw, this counter becomes playable; on activation,
 * draw a card") is fully data-driven via counterRules:
 *   - trigger.opponentDrewThisRound = true
 *   - effect: kind="draw", target="self", amount=1
 *
 * `bonusPerCard` is parameterised on the prompt so future cards using the
 * same primitive can pick a different ratio (e.g. +2 / card) without an
 * engine change.
 *
 * The prompt is surfaced via the hook return; the engine merges it into
 * `gs.pendingPrompt` through applyResults. `confirmPickDiscardForBonus` in
 * playtestEngine.ts handles the resolve side.
 */
export const theFinalStraw: CardHooks = {
  onAttackPlay: (ctx) => {
    if (!ctx.slotId || !ctx.instanceId) {
      // Defensive — both fields are populated by the engine for these
      // hooks. If we somehow lose them, we no-op the discard prompt
      // rather than crash. Card still functions as base Power 4 / Slash.
      return {};
    }
    return {
      prompt: {
        kind: "pick-discard-for-bonus",
        playerNum: ctx.self.num,
        mode: "attack",
        slotId: ctx.slotId,
        zoneCardId: ctx.instanceId,
        selectedInstanceIds: [],
        sourceCardName: ctx.card.name,
        bonusPerCard: 1,
      },
    };
  },
  onDefendPlay: (ctx) => {
    if (!ctx.slotId || !ctx.instanceId) return {};
    return {
      prompt: {
        kind: "pick-discard-for-bonus",
        playerNum: ctx.self.num,
        mode: "defend",
        slotId: ctx.slotId,
        zoneCardId: ctx.instanceId,
        selectedInstanceIds: [],
        sourceCardName: ctx.card.name,
        bonusPerCard: 1,
      },
    };
  },
};
